(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/*global module */
/*jshint devel:true */
/*jshint strict:true */
/*jshint -W097 */
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.qpall = exports.redir2secOnHost = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getUrlQstringPairs = getUrlQstringPairs;
exports.getQstringValue = getQstringValue;
exports.addPolyfill = addPolyfill;
exports.getDomOffset = getDomOffset;
exports.ensureWithPolyfill = ensureWithPolyfill;
exports.canGetBrowserLoc = canGetBrowserLoc;
exports.requestLatLonBrowserData = requestLatLonBrowserData;
exports.matchAnyHost = matchAnyHost;
exports.isDevHost = isDevHost;
exports.RedirectToSecureHelper = RedirectToSecureHelper;
exports.docUrlWatcher = docUrlWatcher;

var _DryFunctions = require('./DryFunctions.es6');

var cerr = console.error;
var clo = console.log;

function getUrlQstringPairs() {
    var qsSplit = [],
        qsPairs = {},
        s = document.location.search;
    s = s.substring(1);
    if (s) {
        qsSplit = s.split('&');
        if (qsSplit && qsSplit.length) {
            qsSplit.forEach(function (kvp) {
                var _kvp$split = kvp.split('='),
                    _kvp$split2 = _slicedToArray(_kvp$split, 2),
                    k = _kvp$split2[0],
                    v = _kvp$split2[1];

                qsPairs[k] = v;
            });
        }
    }
    return qsPairs;
}
function getQstringValue(key) {
    var retVal = void 0;
    var pairs = getUrlQstringPairs();
    if (pairs && Object.keys(pairs) && Object.keys(pairs).length) {
        if (Object.keys(pairs).includes(key)) {
            retVal = pairs[key];
        }
    }
    return retVal;
}

function addPolyfill(name) {
    var haveIt = false,
        url = void 0,
        hasPromise = window.Promise ? true : false;
    switch (name) {
        case 'promise':
            url = 'https://cdn.jsdelivr.net/npm/es6-promise@4/dist/es6-promise.min.js';
            haveIt = true;
            break;
        case 'NodeList.forEach':
            url = 'https://cdn.jsdelivr.net/npm/mdn-polyfills@5.5.0/NodeList.prototype.forEach.js';
            haveIt = true;
            break;
        default:
            throw new Error('unsupported polyfill: ' + name + ' - MO+7DVfmY');
    }
    var prom = false;
    if (haveIt) {
        var scr = document.createElement('script');
        scr.setAttribute('src', url);
        if (hasPromise) {
            prom = new Promise(function (resolve, reject) {
                scr.addEventListener('load', function () {
                    resolve();
                });
            });
        }
        document.querySelector('head').appendChild(scr);
        console.log('%cPolyfilling ' + name, 'font-size:1.6em;color:purple');
        console.log('%c' + url, 'font-size:1.3em;color:purple');
    }
    return prom;
}

function getDomOffset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft, height: rect.height, width: rect.width };
}

function ensureWithPolyfill(name) {
    switch (name) {
        case 'promise':
            if (!window.Promise) {
                addPolyfill(name);
            }
            break;
        case 'NodeList.forEach':
            if (!NodeList.prototype.forEach) {
                return addPolyfill(name);
            }
            break;
        default:
            throw new Error('unsupported polyfill: ' + name + ' - ZdLNN-9-hu');
    }
}

/**
 * Checks Browser to see if geolocation is available. If so, returns the "state" of geolocation availability (see below).
 * Returns Promise. on success returns {success: true|false, state:'granted'|'prompt|'denied'}, on error returns string describing problem
 * @return {Promise} on success: object: {success: true|false, state:'granted'|'prompt|'denied'}, on error: string describing problem
 */
function canGetBrowserLoc() {
    return new Promise(function (resolv, rej) {
        var q = void 0;
        var n = 'navigator.permissions.query';
        try {
            q = navigator.permissions.query({ name: 'geolocation' });
            q.then(function (permStat) {
                // console.log('nav.perms.query.then: ', q, permStat, permStat.state);
                if (permStat && permStat.state) {
                    if (['granted', 'prompt'].includes(permStat.state)) {
                        resolv({
                            success: true,
                            state: permStat.state
                        });
                    } else {
                        rej(n + ' state was UNKNOWN: ', permStat);
                    }
                } else {
                    rej(n + ' state was: ', permStat);
                }
            }, function (e) {
                console.error('ERROR in ' + n + ': ', e);
            });
        } catch (e) {
            rej(n + ' must have failed: ', e);
        }
    });
}

function requestLatLonBrowserData() {
    return new Promise(function (resolv, rej) {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {
                resolv(position);
            }, function (errPos) {
                rej(errPos);
            });
        } else {
            rej();
        }
    });
}

// REDIRECT TO https: if not dev environment
var devHosts = ['localhost', 'ormsby', 'chriso'];

function matchAnyHost(a) {
    if (!(0, _DryFunctions.isArray)(a)) {
        return;
    }
    var iz = false;
    a.forEach(function (s) {
        if (window.location.hostname.match(s)) {
            iz = true;
        }
    });
    return iz;
}
function _redir2secOnHost(hstArr) {
    if (hstArr && !(0, _DryFunctions.isArray)(hstArr)) {
        return;
    }
    var myDevHosts = hstArr || devHosts;
    if (!matchAnyHost(myDevHosts) && window.location.protocol !== 'https:') {
        window.location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
    }
}

exports.redir2secOnHost = _redir2secOnHost;
function isDevHost(hstArr) {
    var myDevHosts = hstArr || devHosts;
    return matchAnyHost(myDevHosts);
}

// constructor
function RedirectToSecureHelper() {
    var myDevHosts = devHosts;
    var R2S = {
        setDevHosts: function setDevHosts(hostsArr) {
            try {
                if (!Array.isArray(hostsArr)) {
                    cerr('Browser(helper).setDevHosts failed.  Bad arg: ', hostsArr);return;
                }
            } catch (e) {
                cerr('9>/oNoreEP');
            }
            myDevHosts = hostsArr;
        },
        getDevHosts: function getDevHosts() {
            return myDevHosts;
        },
        resetDevHosts: function resetDevHosts() {
            myDevHosts = devHosts;
        },
        isDevHost: function isDevHost() {
            return matchAnyHost(myDevHosts);
        },
        redir2secOnHost: function redir2secOnHost() {
            return _redir2secOnHost(myDevHosts);
        },
        help: function help() {
            for (var att in R2S) {
                if (typeof R2S[att] === 'function') {
                    clo('func ' + att);
                }
            }
        }
    };
    return R2S;
}

function docUrlWatcher() {
    var CALLBACKS = {};
    var DUW = {
        registerUrlWatcher: function registerUrlWatcher(cb) {
            CALLBACKS.popstate = cb;
            // window.addEventListener('popstate', function(e){
            //     console.log('URL CHANGED: ',e);
            //     CALLBACKS.popstate(e);
            // });
            window.onpopstsate = function (e) {
                console.log('URL CHANGED: ', e);
                CALLBACKS.popstate(e);
            };
        },
        registerHashWatcher: function registerHashWatcher(cb) {
            CALLBACKS.hashchange = cb;
            // window.addEventListener('hashchange', function(e){
            //     console.log('URL CHANGED: ',e);
            //     CALLBACKS.hashchange(e);
            // });
            window.onhashchange = function (e) {
                console.log('URL CHANGED: ', e);
                CALLBACKS.hashchange(e);
            };
        }
    };
    return DUW;
}

var qpall = exports.qpall = {
    encode: function encode(str) {
        return encodeURIComponent(str).replace(/[!'()]/g, window.escape).replace(/\*/g, "%2A").replace(/[.]/g, "%2E").replace(/%/g, '=');
    },
    decode: function decode(str) {
        return decodeURIComponent(str.replace(/[=]/g, '%'));
    }
};

module.exports = {
    getUrlQstringPairs: getUrlQstringPairs,
    getQstringValue: getQstringValue,
    addPolyfill: addPolyfill,
    getDomOffset: getDomOffset,
    ensureWithPolyfill: ensureWithPolyfill,
    canGetBrowserLoc: canGetBrowserLoc,
    requestLatLonBrowserData: requestLatLonBrowserData,
    isDevHost: isDevHost,
    RedirectToSecureHelper: RedirectToSecureHelper,
    docUrlWatcher: docUrlWatcher,
    qpall: qpall
};

},{"./DryFunctions.es6":3}],2:[function(require,module,exports){
/*global module, console */
/*jshint devel:true */
/*jshint strict:true */
/*jshint -W097 */
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeNode = makeNode;
exports.makeNodesByTagname = makeNodesByTagname;
exports.FreezeBody = FreezeBody;

var _DryFunctions = require('./DryFunctions.es6');

function makeNode(opts) {
    var html = void 0;
    if (opts) {
        if ((0, _DryFunctions.isString)(opts)) {
            html = opts;
        } else {
            if (opts.html) {
                html = opts.html;
            } else if (opts.txt) {
                html = '<span>' + opts.txt + '</span>';
            }
        }
    }
    // console.log('makeNode: html: ', html);
    var domel = void 0;
    var d = document.createElement('div');
    d.innerHTML = html;
    try {
        if (opts.wrapDiv) {
            domel = d;
        } else {
            domel = d.firstElementChild;
        }
    } catch (e) {
        console.error('DomHelper.makeNode error: ', e, html);
    }
    return domel;
}

function makeNodesByTagname(nList) {
    var ret = [];
    nList = nList || [];
    nList.forEach(function (nn) {
        var e = document.createElement(nn);
        ret.push(e);
    });
    return ret;
}

function FreezeBody() {
    var bodyScrollTop = void 0;
    return {
        freezeBody: function freezeBody() {
            bodyScrollTop = document.body.scrollTop || document.documentElement.scrollTop || 0;
            document.body.classList.add('izFrozen');
        },
        unfreezeBody: function unfreezeBody() {
            document.body.classList.remove('izFrozen');
            if (bodyScrollTop || bodyScrollTop === 0) {
                document.body.scrollTop = Math.abs(bodyScrollTop);
                document.documentElement.scrollTop = Math.abs(bodyScrollTop);
                bodyScrollTop = void 0;
            }
        }
    };
}

module.exports = {
    FreezeBody: FreezeBody(),
    makeNode: makeNode,
    makeNodesByTagname: makeNodesByTagname
};

},{"./DryFunctions.es6":3}],3:[function(require,module,exports){
/*global console, module */
/*jshint devel:true */
/*jshint strict:true */
/*jshint -W097 */
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isLocalhost = isLocalhost;
exports.luhnCheck = luhnCheck;
exports.isArray = isArray;
exports.isString = isString;
exports.isBool = isBool;
exports.argsToArray = argsToArray;
exports.bindAllFuncs = bindAllFuncs;
var LocalhostHosts = ['localhost', 'ormsby', 'chriso'];
function isLocalhost() {
    var ret = false;
    LocalhostHosts.forEach(function (s) {
        if (window.location.hostname.match(s)) {
            ret = true;
        }
    });
    return ret;
}

var emailRegx = exports.emailRegx = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;

function luhnCheck(val) {
    /*jshint -W016 */
    var luhnArr = [[0, 2, 4, 6, 8, 1, 3, 5, 7, 9], [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]];
    var sum = 0;
    val.replace(/\D+/g, "").replace(/[\d]/g, function (c, p, o) {
        sum += luhnArr[o.length - p & 1][parseInt(c, 10)];
    });
    return sum % 10 === 0 && sum > 0;
}

function isArray(a) {
    return Object.prototype.toString.call(a) === '[object Array]';
}
function isString(a) {
    return Object.prototype.toString.call(a) === '[object String]';
}

function isBool(b) {
    return b === true || b === false;
}

function argsToArray(a) {
    return Array.prototype.slice.call(a);
}

function bindAllFuncs(obj, cfg) {
    var verbose = cfg && cfg.verbose;
    var name = cfg && cfg.name;
    for (var att in obj) {
        if (obj.hasOwnProperty(att) && typeof obj[att] === 'function') {
            if (isLocalhost() && verbose) {
                console.log('binding func ' + att + ' to:', name ? name : obj);
            }
            obj[att] = obj[att].bind(obj);
        }
    }
}

module.exports = {
    isLocalhost: isLocalhost,
    emailRegx: emailRegx,
    luhnCheck: luhnCheck,
    isArray: isArray,
    isBool: isBool,
    isString: isString,
    argsToArray: argsToArray,
    bindAllFuncs: bindAllFuncs
};

},{}],4:[function(require,module,exports){
/* global console, ga */
/*jshint unused:true, eqnull:true, curly:true */
/*jshint strict:true */
/*jshint browser: true, browserify: true */
/*jshint -W030, -W069 */
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = function (cfg) {
    var MY_GA = void 0,
        debugMode = false,
        useEcommerce = true;

    if (debugMode) {
        console.log('%cGoogleAnalytics is in DEBUG MODE! (bad in prod!) vGAMHes6', 'background:#B50F0F;color:white;font-size:1.6em;padding:1em');
    }

    if (cfg) {
        if (cfg.debug) {
            debugMode = true;
        }
        if (cfg.useEcommerce) {
            useEcommerce = true;
        }
    }
    // always turn off debugMode if not a dev-host
    if (!(0, _Browser.isDevHost)()) {
        debugMode = false;
    }
    if (debugMode) {
        MY_GA = function MY_GA() {
            var argMod = [];
            Array.prototype.slice.call(arguments).forEach(function (arg) {
                if (typeof arg === 'string') {
                    arg = arg.replace(/'/g, '');
                    argMod.push("'" + arg + "'");
                } else if (typeof arg === 'number') {
                    argMod.push("'" + arg + "'");
                } else if ((typeof arg === "undefined" ? "undefined" : _typeof(arg)) === 'object' && (arg.hasOwnProperty('page') || arg.hasOwnProperty('location'))) {
                    var subObj = [];
                    Object.keys(arg).forEach(function (k) {
                        subObj.push("'" + k + "':'" + arg[k] + "'");
                    });
                    argMod.push('{' + subObj.join(',') + '}');
                }
            });
            console.log('simulated GA event: ga(' + argMod.join(', ') + ')');
        };
    } else {
        // NOT debugMode
        (function (i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r;
            i[r] = i[r] || function () {
                (i[r].q = i[r].q || []).push(arguments);
            }, i[r].l = 1 * new Date();
            a = s.createElement(o), m = s.getElementsByTagName(o)[0];
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m);
        })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

        ga('create', gaProfile, 'auto', { 'allowLinker': true });
        ga('require', 'displayfeatures');
        if (useEcommerce) {
            ga('require', 'ecommerce');
        }
        ga('require', 'linker');
        ga('linker:autoLink', ['m2.manhunt.net'], ['manhuntdaily.com'], ['manhuntdiario.com'], ['manhuntagora.com'], ['manhuntcares.com'], ['manhunt.porn'], ['manhuntnet.tumblr.com']);
        MY_GA = function MY_GA() {
            window.ga.apply(window, arguments);
        };
    }
    return MY_GA;
};

var _Browser = require("./Browser.es6");

var gaProfile = 'UA-5700973-24';

},{"./Browser.es6":1}],5:[function(require,module,exports){
/*jshint devel:true, browser:true */
/*jshint -W097 */
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ensureGrecap = ensureGrecap;
exports.resetGrecaptcha = resetGrecaptcha;
exports.setupGrecaptcha = setupGrecaptcha;
var ysot = 'You should override this';
var gRecap = {};
gRecap.renderedGrecap = false;
gRecap.rendGrecapId = void 0;
gRecap.rendGrecapCtr = 0;

var globRecapSuccName = 'grecapSuccCbL8rx';
if (!window[globRecapSuccName]) {
    window[globRecapSuccName] = function () {
        console.log('Default recaptcha success callback. ' + ysot);
    };
}

var globRecapLoadSuccName = 'lsesrcCbFunctL11xg';
if (!window[globRecapLoadSuccName]) {
    window[globRecapLoadSuccName] = function () {
        console.error('Default recaptcha LOADED callback. ' + ysot);
    };
}
var msk = '6LfhdzAUAAAAADDJTS7Mpd8cW3eN-4chJqGDoVN7';
function ensureGrecap(_ref) {
    var mainEl = _ref.mainEl,
        resetEl = _ref.resetEl,
        succCb = _ref.succCb,
        resetCb = _ref.resetCb,
        lang = _ref.lang;

    if (window.grecaptcha && window.grecaptcha.render && !gRecap.renderedGrecap) {
        lang = lang || 'en';
        if (typeof resetCb !== 'function') {
            resetCb = function resetCb() {
                console.log('Default recaptcha RESET callback. ' + ysot);
            };
        }
        if (succCb) {
            window[globRecapSuccName] = succCb;
        }
        window.grecaptcha.render('g-recaptcha-wr', {
            'sitekey': msk,
            'hl': lang,
            'callback': globRecapSuccName
        });
        mainEl = mainEl || document.getElementById('g-recaptcha-wr');
        resetEl = resetEl || document.getElementById('g-recaptcha-reset');
        if (mainEl && mainEl.classList) {
            mainEl.classList.remove('hidden');
            if (resetEl && resetEl.addEventListener) {
                resetEl.classList.remove('hidden');
                resetEl.addEventListener('click', function () {
                    resetCb();
                    if (window.grecaptcha) {
                        window.grecaptcha.reset();
                    }
                });
            }
            gRecap.renderedGrecap = true;
        }
    } else {
        if (gRecap.rendGrecapCtr++ < 10) {
            gRecap.rendGrecapId = setTimeout(function () {
                ensureGrecap({
                    mainEl: mainEl, resetEl: resetEl, succCb: succCb, resetCb: resetCb, lang: lang
                });
            }, 700);
        } else {
            console.error('google recaptcha failed to load logshar26');
        }
    }
}
function resetGrecaptcha() {
    gRecap = {};
    gRecap.renderedGrecap = false;
    gRecap.rendGrecapId = void 0;
    gRecap.rendGrecapCtr = 0;
}
function setupGrecaptcha(succCb) {
    // console.log('setupGrecaptcha called!');
    if (succCb && typeof succCb === 'function') {
        window[globRecapLoadSuccName] = succCb;
    }
    var s = document.createElement('script');
    s.src = 'https://www.google.com/recaptcha/api.js?onload=' + globRecapLoadSuccName + '&render=explicit';
    s.setAttribute('async', true);
    s.setAttribute('defer', true);
    document.body.appendChild(s);
}

},{}],6:[function(require,module,exports){
/* global module */
/*jshint unused:true, eqnull:true, curly:true */
/*jshint strict:true */
/*jshint browser: true, browserify: true */
/*jshint -W097 */
"use strict";

/**
 * MicroEvent - to make any js object an event emitter (server or browser)
 *
 * - pure javascript - server compatible, browser compatible
 * - doesn't rely on the browser dom
 * - super simple - you get it immediately, no mystery, no magic involved
 *
 * - create a MicroEventDebug with goodies to debug
 *   - make it safer to use
 */

var MicroEvent	= function(){};
MicroEvent.prototype	= {
    bind	: function(event, fct){
        this._events = this._events || {};
        this._events[event] = this._events[event]	|| [];
        this._events[event].push(fct);
    },
    unbind	: function(event, fct){
        this._events = this._events || {};
        if( event in this._events === false  )	return;
        this._events[event].splice(this._events[event].indexOf(fct), 1);
    },
    trigger	: function(event /* , args... */){
        this._events = this._events || {};
        if( event in this._events === false  )	{ return; }
        for(var i = 0; i < this._events[event].length; i++){
            this._events[event][i].apply(this, Array.prototype.slice.call(arguments, 1));
        }
    }
};

/**
 * mixin will delegate all MicroEvent.js function in the destination object
 *
 * - require('MicroEvent').mixin(Foobar) will make Foobar able to use MicroEvent
 *
 * @param {Object} the object which will support MicroEvent
 */
MicroEvent.mixin	= function(destObject) {
    var props	= ['bind', 'unbind', 'trigger'];
    for(var i = 0; i < props.length; i ++){
        if( typeof destObject === 'function' ){
            destObject.prototype[props[i]]	= MicroEvent.prototype[props[i]].bind(destObject);
        }else{
            destObject[props[i]] = MicroEvent.prototype[props[i]].bind(destObject);
        }
    }
    return destObject;
};

// export in common js
if( typeof module !== "undefined" && ('exports' in module)){
    module.exports	= MicroEvent;
}
},{}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var runRe = function runRe(re, subject) {
    var m = void 0,
        ret = [];
    do {
        m = re.exec(subject);
        if (m) ret.push(m);
    } while (m);
    return ret;
};

var reUpperCase = /[A-Z]/g;
var reLowerCase = /[a-z]/g;
var reDigits = /[0-9]/g;
var reSymbols = /[-_@!#$%^&*()}{|'"?/>.<,~`[=\]]/g;
var reChars = /[a-zA-Z]/g;
var reRepeatChars = /(.)\1/g;
var reRepeat3Chars = /(.)\1{2}/g;
var reRepeat4Chars = /(.)\1{3}/g;
var reConsecCharU = /[A-Z]{2}/g;
var reConsecCharU3 = /[A-Z]{3}/g;
var reConsecCharU4 = /[A-Z]{4}/g;
var reConsecCharL = /[a-z]{2}/g;
var reConsecCharL3 = /[a-z]{3}/g;
var reConsecCharL4 = /[a-z]{4}/g;
var reConsecNum = /[0-9]{2}/g;
var reConsecNum3 = /[0-9]{3}/g;
var reConsecNum4 = /[0-9]{4}/g;
var reConsecNum5 = /[0-9]{5}/g;
var reConsecNum6 = /[0-9]{6}/g;
var _re_upperCase = function _re_upperCase(s) {
    return runRe(reUpperCase, s);
};
var _re_lowerCase = function _re_lowerCase(s) {
    return runRe(reLowerCase, s);
};
var _re_numbers = function _re_numbers(s) {
    return runRe(reDigits, s);
};
var _re_symbols = function _re_symbols(s) {
    return runRe(reSymbols, s);
};

var _sc_numChars = function _sc_numChars(s) {
    return s.length * 4;
};
var _sc_upperCaseChars = function _sc_upperCaseChars(s) {
    return _re_upperCase(s).length ? (s.length - _re_upperCase(s).length) * 2 : 0;
};
var _sc_lowerCaseChars = function _sc_lowerCaseChars(s) {
    return _re_lowerCase(s).length ? (s.length - _re_lowerCase(s).length) * 2 : 0;
};
var _sc_numbers = function _sc_numbers(s) {
    return _re_numbers(s).length * 4;
};
var _sc_symbols = function _sc_symbols(s) {
    return _re_symbols(s).length * 6;
};
var _sc_innerNumOrSym = function _sc_innerNumOrSym(s) {
    return innerNumOrSymbs(s).length * 2;
};

var _sc_lettersOnly = function _sc_lettersOnly(s) {
    return runRe(reChars, s).length === s.length ? s.length * -1 : 0;
};
var _sc_digitsOnly = function _sc_digitsOnly(s) {
    return _re_numbers(s).length === s.length ? s.length * -1 : 0;
};

var _sc_repeatChars2 = function _sc_repeatChars2(s) {
    return runRe(reRepeatChars, s).length * -2;
};
var _sc_repeatChars3 = function _sc_repeatChars3(s) {
    return runRe(reRepeat3Chars, s).length * -3;
};
var _sc_repeatChars4 = function _sc_repeatChars4(s) {
    return runRe(reRepeat4Chars, s).length * -4;
};
var _sc_consecUC = function _sc_consecUC(s) {
    return runRe(reConsecCharU, s).length * -2;
};
var _sc_consecUC3 = function _sc_consecUC3(s) {
    return runRe(reConsecCharU3, s).length * -3;
};
var _sc_consecUC4 = function _sc_consecUC4(s) {
    return runRe(reConsecCharU4, s).length * -4;
};
var _sc_consecLC2 = function _sc_consecLC2(s) {
    return runRe(reConsecCharL, s).length * -2;
};
var _sc_consecLC3 = function _sc_consecLC3(s) {
    return runRe(reConsecCharL3, s).length * -3;
};
var _sc_consecLC4 = function _sc_consecLC4(s) {
    return runRe(reConsecCharL4, s).length * -4;
};
var _sc_consecDIG2 = function _sc_consecDIG2(s) {
    return runRe(reConsecNum, s).length ? (runRe(reConsecNum, s).length + 1) * -2 : 0;
};
var _sc_consecDIG3 = function _sc_consecDIG3(s) {
    return runRe(reConsecNum3, s).length ? (runRe(reConsecNum3, s).length + 1) * -3 : 0;
};
var _sc_consecDIG4 = function _sc_consecDIG4(s) {
    return runRe(reConsecNum4, s).length ? (runRe(reConsecNum4, s).length + 1) * -4 : 0;
};
var _sc_consecDIG5 = function _sc_consecDIG5(s) {
    return runRe(reConsecNum5, s).length ? (runRe(reConsecNum5, s).length + 1) * -5 : 0;
};
var _sc_consecDIG6 = function _sc_consecDIG6(s) {
    return runRe(reConsecNum6, s).length ? (runRe(reConsecNum6, s).length + 1) * -6 : 0;
};

var innerNumOrSymbs = function innerNumOrSymbs(s) {
    var s2 = s.substr(1, s.length - 2);
    return _re_numbers(s2).concat(_re_symbols(s2));
};

var requirementsPass = exports.requirementsPass = function requirementsPass(s) {
    // console.log('requirementsPass called: ', s);
    var len = s.length >= 8;
    var u = _re_upperCase(s).length;
    var l = _re_lowerCase(s).length;
    var d = _re_numbers(s).length;
    var y = _re_symbols(s).length;
    // console.log('len, u, l, d, y', len, u, l, d, y);
    if (!u) throw 'upper';
    if (!l) throw 'lower';
    if (!d) throw 'number';
    if (!y) throw 'symbol';
    if (!len) throw 'length';
    // console.log('requirementsPass about to pass...');
    return true;
};

var strengthScore = exports.strengthScore = function strengthScore(s) {
    var posSc = 0;
    var negSc = 0;
    var retVal = void 0;

    var chars_score = _sc_numChars(s);
    posSc += chars_score;

    var upper = _sc_upperCaseChars(s);
    posSc += upper;

    var lower = _sc_lowerCaseChars(s);
    posSc += lower;

    var digi = _sc_numbers(s);
    posSc += digi;

    var symb = _sc_symbols(s);
    posSc += symb;

    var midNumsSymbs = _sc_innerNumOrSym(s);
    posSc += midNumsSymbs;

    var onlyChars = _sc_lettersOnly(s);
    negSc += onlyChars;

    var _onlyNums = _sc_digitsOnly(s);
    negSc += _onlyNums;

    var _repeatedChars = _sc_repeatChars2(s);
    negSc += _repeatedChars;

    var _repeatedChars3 = _sc_repeatChars3(s);
    negSc += _repeatedChars3;

    var _repeatedChars4 = _sc_repeatChars4(s);
    negSc += _repeatedChars4;

    var _consecUc2 = _sc_consecUC(s);
    negSc += _consecUc2;

    var _consecUc3 = _sc_consecUC3(s);
    negSc += _consecUc3;

    var _consecUc4 = _sc_consecUC4(s);
    negSc += _consecUc4;

    var _consecLc2 = _sc_consecLC2(s);
    negSc += _consecLc2;

    var _consecLc3 = _sc_consecLC3(s);
    negSc += _consecLc3;

    var _consecLc4 = _sc_consecLC4(s);
    negSc += _consecLc4;

    var _consecDig2 = _sc_consecDIG2(s);
    negSc += _consecDig2;

    var _consecDig3 = _sc_consecDIG3(s);
    negSc += _consecDig3;

    var _consecDig4 = _sc_consecDIG4(s);
    negSc += _consecDig4;

    var _consecDig5 = _sc_consecDIG5(s);
    negSc += _consecDig5;

    var _consecDig6 = _sc_consecDIG6(s);
    negSc += _consecDig6;

    retVal = posSc + negSc;

    try {
        requirementsPass(s);
    } catch (e) {
        retVal = retVal >= 100 ? 90 : retVal;
    } // eslint-disable-line
    return retVal;
};

},{}],8:[function(require,module,exports){
/*jshint unused:true, eqnull:true, curly:true */
/*jshint strict:true */
/*jshint browser: true, browserify: true, devel: true */
"use strict";

var DH = function DH() {
    // let bodyOverflowOrig = 'auto';
    var bodyScrollTop = void 0;
    var dh = {
        freezeBody: function freezeBody() {
            // bodyOverflowOrig = document.body.style.overflow;
            // document.body.style.overflow = 'hidden';
            bodyScrollTop = document.body.scrollTop || document.documentElement.scrollTop || 0;
            document.body.classList.add('izFrozen');
        },
        releaseBody: function releaseBody() {
            // document.body.style.overflow = bodyOverflowOrig || 'auto';
            document.body.classList.remove('izFrozen');
            if (bodyScrollTop || bodyScrollTop === 0) {
                document.body.scrollTop = Math.abs(bodyScrollTop);
                document.documentElement.scrollTop = Math.abs(bodyScrollTop);
                bodyScrollTop = void 0;
            }
        },
        makeNode: function makeNode(html) {
            var domel = void 0,
                d = document.createElement('div');
            d.innerHTML = html;
            try {
                domel = d.firstElementChild;
            } catch (e) {
                console.error('DomHelper.makeNode error: ', e, html);
            }
            return domel;
        },
        makeNodes: function makeNodes(nList) {
            var ret = [];
            nList = nList || [];
            nList.forEach(function (nn) {
                var e = document.createElement(nn);
                ret.push(e);
            });
            return ret;
        }
    };
    return dh;
};

module.exports = new DH();

},{}],9:[function(require,module,exports){
/*jshint devel:true, browser:true */
/*jshint -W097 */
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sessionPlanInfo = undefined;
exports.getV5ContentModal = getV5ContentModal;
exports.throwModal = throwModal;
exports.showLoadingCurtain = showLoadingCurtain;
exports.hideLoadingCurtain = hideLoadingCurtain;
exports.displGenFb = displGenFb;
exports.hijackFooterLinks = hijackFooterLinks;
exports.setupLegalLinks = setupLegalLinks;

var _DOM = require('../../common/js/modules/DOM.es6');

function gtOkB() {
    // this is non-minified version: minified version is directly below
    var d = document.createElement('div');
    var b1 = document.createElement('button');
    b1.setAttribute('data-hook', 'logpg-btn-cancel');
    b1.textContent = document.getElementById('oktxt').getAttribute('data-val');
    b1.setAttribute('style', 'margin-right: 0.5em;');
    b1.className = 'm5 hvr';
    b1.setAttribute('style', 'font-size:1em;');
    d.appendChild(b1);
    d.setAttribute('style', 'margin-top: 1em;text-align: right;');
    return d;
}
function getV5ContentModal(opts) {
    // this is non-minified version: minified version is directly below
    var title = '',
        mainContent,
        closeFunc,
        addClass,
        closeCallback = function closeCallback() {};
    if (opts) {
        if (opts.title) {
            title = opts.title;
        }
        if (opts.closeCallback) {
            closeCallback = opts.closeCallback;
        }
        closeFunc = function closeFunc() {
            closeCallback();
            parentEl.remove();
        };
        if (opts.mainContent) {
            mainContent = opts.mainContent;
        }
        if (opts.addClass) {
            addClass = opts.addClass;
        }
    }
    var curt, parentEl, closeX;
    curt = document.createElement('div');
    curt.className = 'v5cmwCurtain contMod';
    parentEl = curt;

    closeX = document.createElement('div');
    closeX.className = 'v5cmwCloseX';
    closeX.addEventListener('click', closeFunc);

    var modalEl = document.createElement('div');
    modalEl.className = 'v5contentModalStd';
    if (addClass) {
        modalEl.className = 'v5contentModalStd ' + addClass;
    }
    var headr = document.createElement('div');
    headr.className = 'v5contHeader';
    var titWrp = document.createElement('div');
    titWrp.className = 'v5cTitleWrap';
    var tit = document.createElement('div');
    tit.className = 'v5cTitle';
    if (title) {
        tit.textContent = title;
    }
    titWrp.appendChild(tit);
    headr.appendChild(titWrp);

    if (closeX) {
        headr.appendChild(closeX);
    }
    modalEl.appendChild(headr);

    var contEl = document.createElement('div');
    contEl.className = 'v5contBody';
    if (mainContent) {
        contEl.appendChild(mainContent);
    }
    modalEl.appendChild(contEl);

    var butts = gtOkB();
    contEl.appendChild(butts);
    butts.querySelector('button').addEventListener('click', function () {
        parentEl.remove();
        closeCallback();
    });

    parentEl.appendChild(modalEl);
    parentEl.addEventListener('click', closeFunc);
    modalEl.addEventListener('click', function (e) {
        e.stopPropagation();
    });
    return parentEl;
}
function throwModal(opts) {
    var d = document.createElement('div');
    d.innerHTML = opts.html;
    var cmOpts = {
        title: opts.title,
        mainContent: d
    };
    if (opts.addClass) {
        cmOpts.addClass = opts.addClass;
    }
    if (opts.closeCallback) {
        cmOpts.closeCallback = opts.closeCallback;
    }
    var parEl = getV5ContentModal(cmOpts);
    document.body.appendChild(parEl);
}

function showLoadingCurtain() {
    var t = document.querySelector('[data-template-name=animated_loading_nine_grid]');
    var d = document.createElement('div');
    d.id = 'shwldgcubeanim';
    d.className = 'loadingIcon';
    d.innerHTML = t.innerHTML;
    document.body.appendChild(d);
}
function hideLoadingCurtain() {
    var el = document.querySelector('#shwldgcubeanim');
    if (el && el.remove) {
        el.remove();
    }
}
function displGenFb() {
    var par = document.querySelector('#rapidreg .formElems');
    if (par) {
        var d = document.createElement('div');
        d.className = 'fullFb';
        d.innerHTML = '<div><p>There has been an error.</p><p>Please reload the page and try again.</p><p>If the problem persists, please contact Customer Service at 1-866-424-9999</p></div>';
        par.appendChild(d);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'm5';
        b.innerHTML = 'OK';
        b.onclick = function () {
            d.remove();
        };
        d.appendChild(b);
    } else {
        console.error('could not find #rapidreg .formElems in displGenFb');
    }
}
function hijackFooterLinks() {
    var langDiv = document.querySelector('#v5-external-footer-langs');
    var langLinks = void 0;
    if (langDiv) {
        langLinks = langDiv.querySelectorAll('a.v5-external-footer-lang');
        if (langLinks) {
            langLinks.forEach(function (a) {
                var chgUrl = a.getAttribute('href');
                a.onclick = function (evt) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    var url = chgUrl + '?' + 'backTo=' + encodeURIComponent(document.location.pathname + document.location.search);
                    // console.log('url: ', url);
                    window.location.href = url;
                };
            });
        } else {
            console.error('v5rapidPurch: 222');
        }
    } else {
        console.error('v5rapidPurch: 225');
    }
}
// SET UP PRIVACY POLICY AND TOS LINKS & FUNCTIONALITY
function setupLegalLinks() {
    var legalLinks = document.querySelectorAll('#privpolfoot, [data-hook=showprivpolicy], [data-hook=showtos]');
    legalLinks.forEach(function (el) {
        el.addEventListener('click', function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            var request = new XMLHttpRequest();
            request.open('POST', el.getAttribute('data-url'));
            request.onload = function () {
                if (request.status === 200) {
                    throwModal({
                        html: request.responseText,
                        title: el.getAttribute('data-title')
                    });
                } else {
                    console.error('There was an error fetching the Privacy Policy!');
                }
            };
            request.onerror = function () {
                console.error('There was an error fetching the Privacy Policy!');
            };
            request.send();
        });
    });
    var csLink = document.getElementById('custsvcfoot');
    if (csLink) {
        csLink.addEventListener('click', function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            var title = csLink.getAttribute('data-title'),
                html = document.getElementById('customerServiceModalContent').innerHTML.trim();
            throwModal({
                html: html,
                title: title,
                addClass: 'narrow'
            });
        });
    }
}

var sessionPlanInfo = exports.sessionPlanInfo = function () {
    var o = {
        set: function set(data) {
            if (data) {
                if (data.planName) {
                    sessionStorage.setItem('pn', data.planName);
                }
                if (data.salePrice) {
                    sessionStorage.setItem('sp', data.salePrice);
                }
                if (data.origPrice) {
                    sessionStorage.setItem('op', data.origPrice);
                }
            }
        },
        get: function get() {
            return {
                planName: sessionStorage.getItem('pn'),
                origPrice: sessionStorage.getItem('op'),
                salePrice: sessionStorage.getItem('sp')
            };
        },
        clear: function clear() {
            sessionStorage.removeItem('pn');
            sessionStorage.removeItem('op');
            sessionStorage.removeItem('sp');
        }
    };
    for (var att in o) {
        if (typeof o[att] === 'function') {
            // console.log(`sessionPlanInfo -> binding func ${att}.`);
            o[att] = o[att].bind(o);
        }
    }
    return o;
}();

},{"../../common/js/modules/DOM.es6":2}],10:[function(require,module,exports){
/*jshint devel:true, browser:true */
/*jshint -W097 */
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.checkUnAvail = checkUnAvail;
exports.setRegFb = setRegFb;
exports.clearRegFb = clearRegFb;
exports.setTextFldStatusIcn = setTextFldStatusIcn;
exports.initRegFormValidators = initRegFormValidators;
exports.initRegPurchForm = initRegPurchForm;

var _loginSharedEs = require('./loginShared.es6.js');

var _GoogleRecaptchaHelper = require('../../common/js/modules/GoogleRecaptchaHelper.es6');

var _Browser = require('../../common/js/modules/Browser.es6');

var _GoogleAnalyticsMH = require('../../common/js/modules/GoogleAnalyticsMH.es6');

var _GoogleAnalyticsMH2 = _interopRequireDefault(_GoogleAnalyticsMH);

var _passwordValidator = require('../../common/js/util/passwordValidator.es6');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BLANKVALOK = true;

var GOOGLE_ANAL = (0, _GoogleAnalyticsMH2.default)();

var L = (0, _Browser.isDevHost)();

function checkUnAvail(name) {
    var url = '/api/en/profiles/' + name.trim() + '/usernameAvailable';
    return new Promise(function (resolv, rej) {
        var req = new XMLHttpRequest();
        req.open('GET', url, true);
        req.setRequestHeader('Content-Type', 'application/json');
        req.onload = function () {
            if (req.status >= 200 && req.status < 400) {
                resolv(name);
            } else {
                rej('fail-inuse');
            }
        };
        req.onerror = function () {
            rej('error');
        };
        req.send();
    });
}

function disRegJoinBtn(enable) {
    var b = document.querySelector('#rapidregsubmit');
    if (enable) {
        b.removeAttribute('disabled');
    } else {
        b.setAttribute('disabled', true);
    }
}
var formHasErrs = function formHasErrs() {
    var els = document.querySelector('#rapidreg form .formElems .regFb');
    return els ? true : false;
};
function setRegFb(_ref) {
    var afterEl = _ref.afterEl,
        beforeEl = _ref.beforeEl,
        txt = _ref.txt,
        isError = _ref.isError;

    var insKeyw = 'afterend';
    var targEl = void 0;
    if (afterEl && afterEl.insertAdjacentElement) {
        targEl = afterEl;
    } else if (beforeEl && beforeEl.insertAdjacentElement) {
        insKeyw = 'beforebegin';
        targEl = beforeEl;
    } else {
        console.error('setRegFb called incorrectly, no afterEl or beforeEl');
    }
    if (!txt) {
        console.error('setRegFb called incorrectly, no txt string passed');
    }
    clearRegFb(targEl, 'immediate');
    var d = document.createElement('div');
    d.className = 'regFb';
    if (isError) {
        d.classList.add('err');
        targEl.classList.remove('succ');
        targEl.classList.add('err');
    } else {
        d.classList.add('succ');
        targEl.classList.remove('err');
        targEl.classList.add('succ');
    }
    d.innerHTML = txt;
    d.onclick = function (evt) {
        clearFb(evt.target);
    };
    targEl.insertAdjacentElement(insKeyw, d);
    disRegJoinBtn();
}

var clearFb = function clearFb(el, immediate) {
    // console.log('clearFb: ', el, immediate);
    if (el) {
        if (immediate) {
            el.remove();
        } else {
            if (el.classList) {
                el.classList.add('fadeOut');
                setTimeout(function () {
                    el.remove();
                    if (!formHasErrs()) {
                        disRegJoinBtn('enable');
                    }
                }, 550);
            }
        }
    } else {
        console.error('error in clearFb: bad el arg');
    }
};
function clearRegFb(el, immediate) {
    var fbEl = void 0;
    var idStr = '#' + el.id;
    var formElKey = Object.keys(regFormElmIds).find(function (k) {
        return regFormElmIds[k].match(idStr);
    });
    if (formElKey && frmValidRules[formElKey].placeErrorAfter) {
        fbEl = document.querySelector(frmValidRules[formElKey].placeErrorAfter) && document.querySelector(frmValidRules[formElKey].placeErrorAfter).nextSibling;
    } else {
        fbEl = el && el.nextSibling;
    }
    if (fbEl.classList && fbEl.classList.contains('regFb')) {
        clearFb(fbEl, immediate);
    }
}
function setTextFldStatusIcn(el, isGood) {
    if (el && el.classList) {
        if (isGood === 'valid') {
            el.classList.remove('err');
            el.classList.add('succ');
        } else if (isGood === 'clear') {
            el.classList.remove('err');
            el.classList.remove('succ');
        } else {
            el.classList.add('err');
            el.classList.remove('succ');
        }
    } else {
        console.error('bad el in set-textfield-feeback-icon');
    }
}

var regFormElmIds = {
    uname: '#reg-name',
    pwd: '#reg-password',
    em: '#reg-email',
    age: '#reg-age',
    tosagree: '#tosagree',
    frm: '#g-recaptcha-wr',
    whichSubscr: '#plansinsetid'
};
var getTestType = function getTestType(tst) {
    var t = typeof tst === 'undefined' ? 'undefined' : _typeof(tst);
    var ret = void 0;
    switch (t) {
        case 'object':
            if (tst.compile) {
                ret = 'regex';
            }
            break;
        case 'function':
            ret = 'function';
            break;
    }
    return ret;
};
var emailRegx = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;
var frmValidRules = {
    uname: {
        tests: {
            plsEnterName: /^.+$/,
            nameCharViol: /^[_a-zA-Z0-9]+$/,
            nameTooShort: /^[_a-zA-Z0-9]{5}[_a-zA-Z0-9]+$/,
            nameTooLong: /^[_a-zA-Z0-9]{0,20}$/
        }
    },
    pwd: {
        tests: {
            plsEnterPwd: /^.+$/,
            // pwdTooShort: /^.{5,}$/,
            // pwdTooLong: /^.{0,20}$/,
            pwdFailsReqs: function pwdFailsReqs(s) {
                try {
                    (0, _passwordValidator.requirementsPass)(s);
                    return true;
                } catch (e) {
                    L && console.log('pwd-valid FAIL: ', e);
                    return false;
                }
            }
        }
    },
    em: {
        tests: {
            plsEnterEm: /^.+$/,
            emInvalid: emailRegx
        }
    },
    age: {
        tests: {
            plsEnterAge: /^.+$/,
            ageRangeBad: function ageRangeBad(n) {
                n = parseInt(n, 10);
                return n > 17 && n < 100;
            }
        }
    },
    tosagree: {
        getVal: function getVal() {
            return document.getElementById('tosagree').checked ? 'true' : 'false';
        },
        placeErrorAfter: '#toswrapr',
        tests: {
            youMustAgree: function youMustAgree(n) {
                return n === 'true';
            }
        }
    },
    frm: {
        getVal: function getVal() {
            /* global grecaptcha */
            var ret = '';
            try {
                ret = grecaptcha && grecaptcha.getResponse();
            } catch (e) {
                console.error('frm.getVal: ', e);
                ret = '';
            }
            return ret;
        },
        tests: {
            recapFail: function recapFail(str) {
                return !!str;
            }
        }
    },
    whichSubscr: {
        getVal: function getVal() {
            var ret = '';
            var cb = document.querySelector('#rapidreg [name=whichSubscr]:checked');
            var saved = void 0;
            try {
                saved = document.querySelector('#plansinsetid').value;
            } catch (e) {}
            if (cb && saved) {
                ret = cb.getAttribute('data-pisid') === saved ? saved : void 0;
            }
            return ret;
        },
        placeErrorAfter: '#rrRadGrp',
        tests: {
            chooseMemshp: function chooseMemshp(str) {
                return !!str;
            }
        }
    }
};

var doValidations = function doValidations(name, blankOk) {
    var errors = [];
    var failErr = false;
    var hasVerr = false;
    if (!Object.keys(frmValidRules).includes(name)) {
        console.error('bad name in validate-rules function.');
        failErr = true;
    }
    var rules = frmValidRules[name] && frmValidRules[name].tests;
    if (!rules) {
        console.error('error in doValidations function: no rules found for: ', name);
        failErr = true;
    }
    var val = void 0,
        tmp = void 0,
        cstmVal = false;
    try {
        cstmVal = frmValidRules[name].getVal ? true : false;
        val = cstmVal ? frmValidRules[name].getVal() : document.querySelector(regFormElmIds[name]).value;
        tmp = val.trim();
        if (!cstmVal && val !== tmp) {
            val = tmp;
            document.querySelector(regFormElmIds[name]).value = val;
        }
    } catch (e) {
        console.error('error in doValidations function: no value from el with id: ', regFormElmIds[name]);
        failErr = true;
    }
    if (failErr) {
        return void 0;
    }
    Object.keys(rules).forEach(function (k) {
        var isBlank = false;
        var erObj = {};
        if (hasVerr) {
            return;
        }
        if (blankOk && !val) {
            isBlank = true;
        }
        var tt = getTestType(rules[k]);

        if (tt === 'regex') {
            if (!val.match(rules[k])) {
                hasVerr = true;
                erObj[k] = isBlank;
                errors.push(erObj);
            }
        } else if (tt === 'function') {
            if (!rules[k](val)) {
                hasVerr = true;
                erObj[k] = isBlank;
                errors.push(erObj);
            }
        } else {
            console.error('bad rule type in doValidations: ', k, tt);
        }
    });
    return errors && errors.length ? errors : true;
};
// when error comes from API, which element does it belong to?
var api2localFb = {
    nameNotAvail: {
        reg: /^Sorry! That name is not available|Sorry, the name .+ is already being used/,
        elKey: 'uname'
    },
    nameCharViol: {
        reg: /^Your member name may only contain letters/,
        elKey: 'uname'
    },
    nameTooShort: {
        reg: /^Your member name must be at least/,
        elKey: 'uname'
    },
    nameTooLong: {
        reg: /^Your member name cannot be longer/,
        elKey: 'uname'
    },
    pwdTooShort: {
        reg: /^Your password must be at least/,
        elKey: 'pwd'
    },
    pwdTooLong: {
        reg: /^Your password can't be more/,
        elKey: 'pwd'
    },
    plsEnterPwd: {
        reg: /^Please enter a password/,
        elKey: 'pwd'
    },
    plsEnterEm: {
        reg: /^you must enter an email/,
        elKey: 'em'
    },
    emInvalid: {
        reg: /^Your email address is invalid/,
        elKey: 'em'
    },
    emThrowaway: {
        reg: /^This email is a known throwaway or/,
        elKey: 'em'
    },
    emNoExist: {
        reg: /^This email does not exist or/,
        elKey: 'em'
    },
    emBlkLst: {
        reg: /^email address can not be used/i,
        elKey: 'em'
    },
    plsEnterAge: {
        reg: /^Please enter your age to/,
        elKey: 'age'
    },
    ageRangeBad: {
        reg: /^Please enter an age between/,
        elKey: 'age'
    },
    recapFail: {
        reg: /^Recaptcha Failed/,
        elKey: 'frm'
    }
};
var apiSpclErr = [/Trying to get property of non-object/i];
var apiErrSetFb = function apiErrSetFb(str) {
    var elId = void 0,
        txtKey = void 0,
        hasGenErr = false;
    if (!str) {
        return false;
    }
    apiSpclErr.forEach(function (re) {
        if (str.match(re)) {
            GOOGLE_ANAL('send', 'event', 'rp-login-page', 'general-error');
            hasGenErr = true;
        }
    });
    if (hasGenErr) {
        (0, _loginSharedEs.displGenFb)();
        return;
    }
    Object.keys(api2localFb).forEach(function (k) {
        if (str.match(api2localFb[k].reg)) {
            elId = regFormElmIds[api2localFb[k].elKey];
            txtKey = k;
        }
        if (k === 'recapFail') {
            // special case
            try {
                grecaptcha.reset();
            } catch (e) {}
        }
    });
    if (elId && txtKey) {
        GOOGLE_ANAL('send', 'event', 'rp-api-validation-err', txtKey === 'frm' ? 'grecaptcha' : txtKey);
        setRegFb({
            afterEl: document.querySelector(elId),
            isError: true,
            txt: window.fbTrs[txtKey]
        });
    } else {
        console.error('apiErrSetFb error: no match found for ', str);
    }
};
var vdateFfs = function vdateFfs(name, blankOk) {
    if (window.forceValid) {
        ///@todo DEV REMOVE THIS !!
        return true;
    }
    var ret = false;
    if (!name) {
        return Object.keys(frmValidRules).reduce(function (acc, cur) {
            return acc && vdateFfs(cur, blankOk);
        }, true);
    }
    if (!Object.keys(frmValidRules).includes(name)) {
        console.error('bad name in validate-form-fields function.');
        return void 0;
    }
    console.log('apiErrSetFb: name: ', name);
    var errors = doValidations(name, blankOk);
    var hasNonBlankErr = false;
    if (errors !== true) {
        console.log('ERRORS: ', errors);
        errors.forEach(function (obj) {
            var key = Object.keys(obj)[0];
            console.log('KEY:', key);
            var blankSkipped = obj[key];
            if (blankSkipped) {
                return;
            } else {
                hasNonBlankErr = true;
            }
            GOOGLE_ANAL('send', 'event', 'rp-fe-validation-err', name === 'frm' ? 'grecaptcha' : name);
            setRegFb({
                afterEl: document.querySelector(frmValidRules[name].placeErrorAfter || regFormElmIds[name]),
                isError: true,
                txt: window.fbTrs[key]
            });
        });
        if (!hasNonBlankErr) {
            ret = 'allblank';
        }
    } else {
        ret = true;
    }
    return ret;
};

function initRegFormValidators() {
    console.log('initRegFormValidators: ', regFormElmIds);
    Object.keys(regFormElmIds).forEach(function (n) {
        var el = document.querySelector(regFormElmIds[n]);
        var evtType = void 0;
        switch (el.type) {
            case 'checkbox':
                evtType = 'click';
                break;
            case 'hidden':
                evtType = 'change';
                break;
            default:
                evtType = 'blur';
        }
        console.log('regFormElmIds!!!! ---->', el, evtType);
        el.addEventListener(evtType, function (evt) {
            var isVal = vdateFfs(n, BLANKVALOK);
            console.log('isVal: ', isVal);
            console.log('initRegFormValidators: el.event: ', evtType, evt);
            var prom = void 0;
            if (isVal === true) {
                clearRegFb(evt.target);
                if (n === 'uname') {
                    prom = checkUnAvail(document.querySelector(regFormElmIds.uname).value.trim());
                    prom.then(function () {
                        setTextFldStatusIcn(evt.target, 'valid');
                        GOOGLE_ANAL('send', 'event', 'rp-uname-check', 'success');
                    }, function (err) {
                        GOOGLE_ANAL('send', 'event', 'rp-uname-check', err);
                        setRegFb({
                            afterEl: document.querySelector(regFormElmIds.uname),
                            isError: true,
                            txt: window.fbTrs.nameNotAvail
                        });
                    });
                } else {
                    setTextFldStatusIcn(evt.target, 'valid');
                }
            } else if (isVal === 'allblank') {
                // do nothing, we're blank, so no check nor red-x
                setTextFldStatusIcn(evt.target, 'clear');
                clearRegFb(evt.target);
            } else {
                setTextFldStatusIcn(evt.target);
            }
        });
        // el.addEventListener('touchstart', (evt) => {
        //     const elm = evt && evt.target;
        //     if (elm) {
        //         if (!elm.value || !elm.value.trim()) {
        //             return;
        //         }
        //     }
        //     elm.dispatchEvent(new Event('blur'));
        // });
    });
    var pwdEl = document.querySelector('#reg-password');
    var pwdStrMeter = document.querySelector('[data-hook="pwd-strength-indic"]');
    var pwdStrMeterBar = document.querySelector('[data-hook="meter-bar-cover"]');
    var pwdStrScore = document.querySelector('[data-hook="ps-num"]');
    var checkMark = document.querySelector('[data-hook="pwd_pass_val_chk"]');
    var hideEye = document.querySelector('[data-hook="ps-eye"]');
    var hideEyeIcon = hideEye && hideEye.querySelector('img');
    var eyeSrcYes = '/assets/v6/img/icon/eye-yes.png';
    if (hideEye) {
        hideEye.addEventListener('click', function () {
            if (pwdEl.getAttribute('type') === 'password') {
                pwdEl.setAttribute('type', 'text');
                hideEyeIcon.setAttribute('src', eyeSrcYes.replace('-yes', '-no'));
            } else {
                pwdEl.setAttribute('type', 'password');
                hideEyeIcon.setAttribute('src', eyeSrcYes);
            }
        });
    }
    if (pwdStrMeter) {
        if (pwdEl) {
            pwdEl.addEventListener('focus', function () {
                pwdStrMeter.classList.remove('hidden');
            });
            pwdEl.addEventListener('blur', function () {
                var evt = new Event("maybehide", { "bubbles": false, "cancelable": true });
                pwdStrMeter.dispatchEvent(evt);
            });
        }
        pwdStrMeter.addEventListener('maybehide', function (e) {
            setTimeout(function () {
                if (pwdStrMeter.hasAttribute('data-donthide')) {
                    pwdStrMeter.classList.remove('hidden');
                    pwdStrMeter.removeAttribute('data-donthide');
                } else {
                    pwdStrMeter.classList.add('hidden');
                    setTimeout(function () {
                        pwdStrMeter.removeAttribute('data-donthide');
                    }, 2000);
                }
            }, 250);
        });
        pwdStrMeter.addEventListener('click', function () {
            pwdStrMeter.setAttribute('data-donthide', true);
            // pwdStrMeter.classList.remove('hidden');
        });
    }
    var scoreLabelMatrix = {
        0: 'Weak',
        40: 'OK',
        70: 'Strong',
        90: 'HOT !!!'
    };
    var getScoreLabel = function getScoreLabel(n) {
        var keys = Object.keys(scoreLabelMatrix);
        if (n >= keys[keys.length - 1]) {
            // highest score
            return scoreLabelMatrix[keys[keys.length - 1]];
        }
        for (var i = 0; i < keys.length; i++) {
            if (n < +keys[i + 1]) {
                return scoreLabelMatrix[keys[i]];
            }
        }
    };
    window.getScoreLabel = getScoreLabel;
    if (pwdEl) {
        pwdEl.addEventListener('keyup', function (evt) {
            var s = pwdEl.value.trim();
            try {
                (0, _passwordValidator.requirementsPass)(s);
                checkMark.classList.remove('hidden');
            } catch (e) {
                checkMark.classList.add('hidden');
            }
            var score = (0, _passwordValidator.strengthScore)(s);
            if (score < 0) {
                score = 0;
            } else if (score > 100) {
                score = 100;
            }
            if (score < 50) {
                pwdStrScore.classList.remove('dark');
            } else {
                pwdStrScore.classList.add('dark');
            }
            pwdStrScore.innerText = getScoreLabel(score);
            pwdStrMeterBar.setAttribute('style', 'width:' + (100 - score) + '%');
        });
    }
}

// START GOOGLE RECAPTCHA
var addedGrecap = false;
var ensureGrecapWrap = void 0;
function setupRecap(lang) {
    if (!addedGrecap) {
        addedGrecap = true;
        (0, _GoogleRecaptchaHelper.setupGrecaptcha)(recapLoadSuccF);
        ensureGrecapWrap = function ensureGrecapWrap() {
            (0, _GoogleRecaptchaHelper.ensureGrecap)({
                mainEl: document.getElementById('g-recaptcha-wr'),
                resetEl: document.getElementById('g-recaptcha-reset'),
                succCb: recapSuccessF,
                resetCb: recapResetF,
                lang: lang
            });
        };
        ensureGrecapWrap();
    }
}
function recapLoadSuccF() {
    // console.log('%cRecaptcha Loaded Success.  Do something here.', 'font-size:1.3em;color:red');
}
function recapSuccessF() {
    // console.log('%cRecaptcha Completed.  Do something here.', 'font-size:1.3em;color:blue');
}
function recapResetF() {}
// console.log('%cRecaptcha RESET.  Do something here.', 'font-size:1.3em;color:purple');

// END GOOGLE RECAPTCHA

// let regFormEls;
function initRegFormEls(lang) {
    var par = regPurchWrapEl || document; // defined on init of helper
    par.querySelector('#reg-password').addEventListener('change', function (e) {
        try {
            if (!e.target.value.length) {
                return;
            }
        } catch (err) {
            console.error('error in initRegFormEls 509: ', err);
        }
        setupRecap(lang);
    });
    var initSelected = void 0;
    par.querySelectorAll('#rapidreg [name="whichSubscr"]').forEach(function (el) {
        if (el.checked) {
            initSelected = el;
        }
        el.addEventListener('click', function () {
            var hid = par.querySelector('#plansinsetid');
            var chgEvt = new Event('change');
            hid.value = el.getAttribute('data-pisid');
            hid.dispatchEvent(chgEvt);
        });
    });
    var plansinsetid = par.querySelector('#plansinsetid');
    if (plansinsetid && initSelected) {
        plansinsetid.setAttribute('value', initSelected.getAttribute("data-plnid"));
    }
}

function getFrmDta(browserCoords) {
    var f = document.querySelector('form#rapidreg');
    var data = {};
    var elIds = {
        username: 'reg-name',
        password: 'reg-password',
        email: 'reg-email',
        age: 'reg-age',
        tosagree: 'tosagree'
    };
    Object.keys(elIds).forEach(function (k) {
        try {
            var el = f.querySelector('#' + elIds[k]);
            if (el && el.type && el.type === 'checkbox') {
                data[k] = el.checked;
            } else {
                data[k] = el.value.trim();
            }
        } catch (e) {}
    });
    try {
        if (grecaptcha && grecaptcha.getResponse()) {
            data.recaptchaResponse = grecaptcha.getResponse();
        }
    } catch (e) {}
    try {
        // console.log('in getFrmData, browserCoords is ', browserCoords);
        if (browserCoords) {
            data.loc_lat = browserCoords.loc_lat;
            data.loc_lon = browserCoords.loc_lon;
        }
    } catch (e) {}
    // get s from querystring
    var sVal = (0, _Browser.getQstringValue)('s');
    if (sVal) {
        data.s = sVal;
    }
    var subscrPlanId = void 0;
    try {
        var rrf = document.getElementById('rapidreg');
        subscrPlanId = rrf.querySelector('[name="whichSubscr"]:checked').getAttribute('data-plnid');
        if (!subscrPlanId) throw 'no-subscrPlanId';
    } catch (e) {
        try {
            subscrPlanId = document.getElementById('plansinsetid').getAttribute('value');
            if (!subscrPlanId) throw 'no-subscrPlanId-2';
        } catch (e) {
            subscrPlanId = "-1";
        }
    }
    data.plansinsetid = subscrPlanId;
    return data;
}
// window.getFrmDta = getFrmDta;

function isGrecapVis() {
    var el = document.querySelector('#g-recaptcha-wr div');
    try {
        return el && !document.querySelector('.formElems[data-secfunc=reg]').classList.contains('hidden');
    } catch (e) {
        return void 0;
    }
}

function doRapReg(lang, browserCoords) {
    if (!isGrecapVis()) {
        if (ensureGrecapWrap) {
            ensureGrecapWrap();
        } else {
            setupRecap(lang);
        }
    }
    var isValid = vdateFfs();
    var dtaObj = void 0,
        fd = void 0;
    if (!isValid) {
        return false;
    }
    dtaObj = getFrmDta(browserCoords);
    fd = new FormData();
    Object.keys(dtaObj).forEach(function (k) {
        fd.append(k, dtaObj[k]);
    });
    saveSessPlanInfo();
    var selPlanRad = document.querySelector('[name=whichSubscr]:checked');
    var selPlanId = selPlanRad && selPlanRad.value;
    sessionStorage.setItem('rrfdspn', JSON.stringify({
        u: fd.get('username'),
        p: fd.get('password'),
        gr: fd.get('recaptchaResponse'),
        s: selPlanId
    }));
    return new Promise(function (resolv, rej) {
        var mhsv = void 0,
            csrfQs = void 0;
        try {
            mhsv = document.querySelector('[data-hook=mhsv]').textContent.trim();
            csrfQs = '?_csrf_token=' + mhsv;
        } catch (e) {}
        var req = new XMLHttpRequest();
        req.open('POST', '/api/rapidreg/s1', true);
        req.onload = function () {
            // console.log('doRapidReg-in-promise.onload:', req);
            if (req.status >= 200 && req.status < 400) {
                // console.log('doRapidReg-in-promise.RESOLVE()');
                resolv(req);
            } else {
                // console.log('doRapidReg-in-promise.REJECT ()');
                rej(req);
                _loginSharedEs.sessionPlanInfo.clear();
            }
        };
        req.onerror = function () {
            rej(req);
            _loginSharedEs.sessionPlanInfo.clear();
        };
        req.send(fd);
    });
}
function saveSessPlanInfo() {
    var itm = document.querySelector('[name=whichSubscr]:checked');
    var nameEl = void 0,
        pricesEl = void 0,
        origPriceEl = void 0,
        salePriceEl = void 0,
        planName = void 0,
        salePrice = void 0,
        origPrice = void 0;
    if (itm) {
        nameEl = itm.nextElementSibling;
        if (nameEl) {
            planName = nameEl.innerHTML;
            pricesEl = nameEl.nextElementSibling;
        }
        if (pricesEl) {
            salePriceEl = pricesEl.querySelector('span.saleprice');
            if (salePriceEl && salePriceEl.innerHTML) {
                salePrice = salePriceEl.innerHTML;
                origPriceEl = pricesEl.querySelector('span.linethru');
                if (origPriceEl && origPriceEl.innerHTML) {
                    origPrice = origPriceEl.innerHTML;
                }
            }
        }
        if (planName || salePrice) {
            _loginSharedEs.sessionPlanInfo.set({
                planName: planName, salePrice: salePrice, origPrice: origPrice
            });
        }
    }
}
window.saveSessPlanInfo = saveSessPlanInfo;

function initRegFormAction(parent, callback) {
    var FORM = document.querySelector('form#rapidreg');
    FORM.onsubmit = function (evt) {
        if (parent.isLoginFormShowing()) {
            return;
        }
        // console.log('form#rapidreg submitted');
        evt.preventDefault();
        var prm = doRapReg(parent.loginLang, parent.BrowserLoc.getCoords());
        if (prm) {
            (0, _loginSharedEs.showLoadingCurtain)();
            prm.then(function (data) {
                // console.log('IN PROMISE VAR prm:', data, callback);
                try {
                    GOOGLE_ANAL('send', 'event', 'rp-reg-submit', 'success');
                } catch (e) {}
                // window.location.href = '/newuser-finish';
                var rsp = void 0;
                try {
                    rsp = JSON.parse(data.response);
                    callback && callback(rsp);
                } catch (e) {}
                (0, _loginSharedEs.hideLoadingCurtain)();
                document.body.trigger('rapidregsuccess', rsp, parent, callback);
            }, function (xhr) {
                (0, _loginSharedEs.hideLoadingCurtain)();
                var r = JSON.parse(xhr.response);
                if (r.error) {
                    GOOGLE_ANAL('send', 'event', 'rp-reg-submit', 'validation-fail');
                    if (r.error.message) {
                        apiErrSetFb(r.error.message);
                    } else {
                        (0, _loginSharedEs.displGenFb)();
                        console.error('rapid purch error: ', r.error);
                    }
                }
                console.error('FAILURE: registration problem: ', xhr);
            });
        } else {
            evt.preventDefault();
        }
        return false;
    };
    return FORM;
}
var regPurchWrapEl = void 0;
function initRegPurchForm(parent, callback) {
    regPurchWrapEl = parent.el;
    initRegFormEls(parent.loginLang);
    initRegFormValidators();
    initRegFormAction(parent, callback);
}

},{"../../common/js/modules/Browser.es6":1,"../../common/js/modules/GoogleAnalyticsMH.es6":4,"../../common/js/modules/GoogleRecaptchaHelper.es6":5,"../../common/js/util/passwordValidator.es6":7,"./loginShared.es6.js":9}],11:[function(require,module,exports){
/*global MHi18n */
/*jshint esversion: 6, devel: true */
/*jshint strict:true, browserify: true */
/*jshint -W097 */
'use strict';

var _loginSharedEs = require('./loginShared.es6.js');

var _GoogleAnalyticsMH = require('../../common/js/modules/GoogleAnalyticsMH.es6');

var _GoogleAnalyticsMH2 = _interopRequireDefault(_GoogleAnalyticsMH);

var _DryFunctions = require('../../common/js/modules/DryFunctions.es6');

var _Browser = require('../../common/js/modules/Browser.es6');

var _util_domEs = require('../../common/js/util/util_dom.es6.js');

var _rapidPurchRegFormHelperEs = require('./rapidPurchRegFormHelper.es6.js');

var _loginShared = require('./loginShared.es6');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GOOGLE_ANAL = (0, _GoogleAnalyticsMH2.default)();

var redirectToSecureHelper = new _Browser.RedirectToSecureHelper();

var axios = require('axios');

var scriptName = 'rapid reg purchase';

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

var v5rapPurch = function v5rapPurch() {
    var _this2 = this;

    var HASH_REG = '#rpregg';
    var HASH_LOG = '#rplogg';
    var v5RP = {
        initialize: function initialize() {
            var _this = this;

            redirectToSecureHelper.redir2secOnHost();

            // this.collection = new SubscrPlans();
            var pixPath = '/assets/manhunt/images/v5/rappurch';
            var pix = ["P029.png", "P019-crop.png", "P006.png", "P004-crop.png", "P032.png", "P016-right-crop.png"];
            var getPicPath = function getPicPath(p) {
                return [pixPath, p].join('/');
            };
            var rrBigPic = document.getElementById('rrBigPic');
            var picSwitchInt = void 0;
            if (window.matchMedia("(min-width: 841px)").matches && rrBigPic) {
                try {
                    rrBigPic.src = getPicPath(pix[0]);
                    if (pix.length > 1) {
                        var picCtr = 1;
                        picSwitchInt = setInterval(function () {
                            var bordered = pix[picCtr].indexOf('crop') > -1;
                            var newPicSrc = getPicPath(pix[picCtr]);
                            picCtr += 1;
                            if (picCtr >= pix.length) picCtr = 0;
                            rrBigPic.src = newPicSrc;
                            if (bordered) {
                                rrBigPic.parentElement.classList.add('bordered');
                            } else {
                                rrBigPic.parentElement.classList.remove('bordered');
                            }
                        }, 4000);
                        var stopper = document.getElementById('nuRpText').querySelector('span.biggr');
                        if (stopper) stopper.addEventListener('click', function () {
                            if (picSwitchInt) {
                                clearInterval(picSwitchInt);
                            }
                        });
                    }
                    if (pix[0].indexOf('crop') > -1) {
                        rrBigPic.parentElement.classList.add('bordered');
                    }
                } catch (e) {
                    console.error('can not find #rrBigPic');
                }
            }

            if (!window.Promise) {
                (0, _Browser.addPolyfill)('promise');
            }
            try {
                this.pageType = document.querySelector('#rrmMain').getAttribute('data-page');
            } catch (e) {
                this.pageType = 'rp_reg';
            }

            this.el = document.querySelector('[data-hook=rp_formz]');
            this.loginLang = 'en';
            try {
                this.loginLang = this.qs('[name=loginLang]').value;
            } catch (e) {}

            (0, _loginSharedEs.setupLegalLinks)();
            (0, _loginSharedEs.hijackFooterLinks)();

            if (this.isReg()) {
                this.initSubscrRadioClicks().then(function (resp) {
                    // console.log('this.initSubscrRadioClicks:', resp);
                    _this.setupLogRegSwitcher();
                    _this.regForm = (0, _rapidPurchRegFormHelperEs.initRegPurchForm)(_this, _this.rapidRegOnSuccessSegpay);
                    var l1btn = _this.qs('#loginpurchsubmit');
                    l1btn.onclick = function (e) {
                        e.preventDefault();
                        _this.doLogin();
                    };
                    var qsp = (0, _Browser.getUrlQstringPairs)();
                    if (qsp && qsp.lat && qsp.lon) {
                        _this.BrowserLoc.forceSetCoords(qsp.lat, qsp.lon);
                    } else {
                        _this.BrowserLoc.getLoc();
                    }
                }).catch(function (err) {
                    console.warn('initSubscrRadioClicks.err.130:', err);
                });
            }
            document.querySelectorAll('form input').forEach(function (el) {
                el.addEventListener('keydown', function (evt) {
                    if (evt.target.nodeName !== 'INPUT') {
                        return;
                    }
                    if (evt.keyCode && evt.keyCode === 13) {
                        evt.stopPropagation() && evt.preventDefault();
                        evt.returnValue = false;
                        return false;
                    }
                });
            });
            /* This handles browser back & fwd btn clicks, showing the correct form according to the url#hash */
            window.onpopstate = function (e) {
                var H = window.location.hash;
                if (e && H) {
                    if (H === HASH_LOG && !this.isLoginFormShowing()) {
                        // we have LOGIN hash & are not on the LOGIN form
                        this.switchToLogin();
                    } else if (H === HASH_REG && !this.isRegFormShowing()) {
                        // all other instances should show Reg
                        this.switchToReg();
                    }
                } else if (!this.isRegFormShowing()) {
                    this.switchToReg();
                }
            }.bind(this);
            // Check if we have the login hash (HASH_LOG), if so, switch to Login Form
            if (window.location.hash && window.location.hash === HASH_LOG) {
                this.switchToLogin();
            }
            // Check if we are on Reg form (not HASH_LOG), and if so, clear the username & pwd fields
            //  because browsers sometimes auto-pop them with data, which we NEVER want on reg
            if (!window.location.hash || window.location.hash === HASH_REG) {
                this.clearRegForm();
            }
            // See if we have sale price percentage value set
            var LET_HARD_BADGE = false; // for this first round, lets just let the 75%off badge show regardless
            if (!LET_HARD_BADGE) {
                var spp = document.querySelector('#plansPercentage');
                var sppVal = spp && spp.value;
                var sppValInt = sppVal && parseInt(sppVal, 10);
                var sppValEl = document.querySelectorAll('[data-hook=printSalePctg]');
                if (sppValInt && sppValInt !== 0) {
                    if (sppValEl) {
                        sppValEl.forEach(function (el) {
                            el.textContent = sppValInt + '%';
                        });
                    }
                } else if (sppValInt === 0) {
                    document.querySelectorAll('.rpSaleBadge').forEach(function (el) {
                        el && el.classList && el.classList.add('hidden');
                    });
                }
            }
        },
        whichPage: function whichPage() {
            var r = void 0;
            switch (this.pageType) {
                case 'rp_cc':
                    r = 'pay';
                    break;
                case 'rr_fin':
                    r = 'fin';
                    break;
                default:
                    r = 'reg';
            }
            return r;
        },
        isReg: function isReg() {
            return this.whichPage() === 'reg';
        },
        isLoginFormShowing: function isLoginFormShowing() {
            return this.isReg() && !this.qs('#rapidreg .formElems[data-secfunc=login]').classList.contains('hidden');
        },
        isRegFormShowing: function isRegFormShowing() {
            return !this.isLoginFormShowing();
        },
        qs: function qs(s) {
            return this.el.querySelector(s);
        },
        qsa: function qsa(s) {
            return this.el.querySelectorAll(s);
        },
        initSubscrRadioClicks: function initSubscrRadioClicks() {
            var myForm = document.getElementById('rrRadGrp');
            function planSortCompare(a, b) {
                if (a.displayOrder < b.displayOrder) {
                    return -1;
                }
                if (a.displayOrder > b.displayOrder) {
                    return 1;
                }
                return 0;
            }
            function getRadioRow(data) {
                var id = data.id,
                    isDefault = data.isDefault,
                    name = data.name,
                    salePrice = data.salePrice,
                    price = data.price,
                    currency = data.currency,
                    currencySymbol = data.currencySymbol,
                    banner = data.banner,
                    description = data.description,
                    isAutoRenewal = data.isAutoRenewal,
                    specialFree = data.specialFree;

                var saleRow = '',
                    offeredPrice = price,
                    checkedAttr = '',
                    selectedClass = '';
                if (isDefault) {
                    checkedAttr = "checked='checked'";
                    selectedClass = 'selected';
                }
                if (salePrice && +salePrice != +price) {
                    offeredPrice = salePrice;
                    saleRow = '<span class="linethru">' + currencySymbol + '<span data-hook="num2fxd">' + price + '</span>&nbsp;' + currency + '</span>';
                }
                var hidClass = "hidden";
                if (banner) {
                    if (description) hidClass = "";
                    return '<label for="subscr_' + id + '" class="' + selectedClass + ' has-sub-banner">\n                            <input type="radio" name="whichSubscr" id="subscr_' + id + '" value="' + id + '" data-pisid="' + id + '" data-plnid="' + id + '" data-descr="' + name + '" ' + checkedAttr + '>\n                            <div class="ban-and-descr">\n                                <img src="' + banner + '" class="reg-plan-banner">\n                                <span class="plan-details ' + hidClass + '">' + description + '</span>\n                            </div>\n                        </label>';
                } else if (specialFree) {
                    console.log('!!!!!!!!', id, name, price, description);
                    return '<label for="subscr_' + id + '">\n                            <input type="radio" name="whichSubscr" id="subscr_' + id + '" value="' + id + '" data-pisid="' + id + '" data-plnid="' + id + '" data-descr="' + name + '" ' + checkedAttr + '>\n                            <span class="special-free">' + name + '</span>\n                        </label>';
                } else {
                    return '<label for="subscr_' + id + '" class="' + selectedClass + '">\n                            <input type="radio" name="whichSubscr" id="subscr_' + id + '" value="' + id + '" data-pisid="' + id + '" data-plnid="' + id + '" data-descr="' + name + '" ' + checkedAttr + '>\n                            <span>' + name + '</span>\n                            <span class="prices">' + saleRow + '\n                                <span class="saleprice">' + currencySymbol + '<span data-hook="num2fxd">' + offeredPrice + '</span>&nbsp;' + currency + '</span>\n                            </span>\n                        </label>';
                }
            }
            var planSetId = (0, _Browser.getQstringValue)('set');
            var url = "/api/plans/ua" + (planSetId ? '/' + planSetId : '');
            var freeNoplan = {
                currency: "USD", currencySymbol: "$", description: "", displayOrder: 500000000, id: "0",
                isAutoRenewal: false, isDefault: false,
                specialFree: true,
                name: MHi18n && MHi18n.general && MHi18n.general.joinWfreeLimAcct || "Join with Free Limited Account",
                price: "", salePrice: "", specialPlan: "", tokensToGrant: "0", url: "", usdEquivalent: ""
            };
            var plans = [];
            var radioButtons = void 0;
            // function tempDevModifyReturnDataNotForProduction(d) {
            //     const retArray = [];
            //     d.forEach(plan => {
            //         const toks = +plan.tokensToGrant;
            //         if (toks === 0) {
            //             retArray.push(plan);
            //         } else if (toks === 30) {
            //             plan.description = 'Renews at $14 every 30 days, until cancelled.';
            //             plan.banner = '/assets/manhunt/images/v5/rappurch/reg-plan-30.png';
            //             retArray.push(plan);
            //         } else if (toks ===7) {
            //             plan.isDefault = true;
            //             plan.description = 'Renews at $8, after 7 day trial period, until cancelled.';
            //             plan.banner = '/assets/manhunt/images/v5/rappurch/reg-plan-7-special.png';
            //             retArray.push(plan);
            //         }
            //     });
            //     return retArray;
            // }
            return axios.get(url).then(function (resp) {
                resp.data.results.subscriptions.forEach(function (s) {
                    var p = JSON.parse(s);
                    if (p.isDefault && p.isAutoRenewal) {
                        document.getElementById('plansinsetid').value = p.id;
                    }
                    plans.push(p);
                });
                plans.push(freeNoplan);
                var htmlOut = '';
                plans.sort(planSortCompare);

                ///@todo REMOVE THIS if BEFORE RELEASE
                // if (isLocalhost() && !planSetId) {
                //     console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
                //     tempDevModifyReturnDataNotForProduction(plans).forEach(p => {
                //         let html = getRadioRow(p);
                //         htmlOut += html;
                //     });
                // } else {
                //     if (isLocalhost()) {
                //         plans.filter(p => p.tokensToGrant<91).forEach(p => {
                //             let html = getRadioRow(p);
                //             htmlOut += html;
                //         });
                //     } else {
                plans.forEach(function (p) {
                    var html = getRadioRow(p);
                    htmlOut += html;
                });
                // }
                // }
                radioButtons = (0, _util_domEs.makeNode)('<div class="rap-reg-plans-21">' + htmlOut + '</div>');
                myForm.insertAdjacentElement('afterbegin', radioButtons);
                var allLabels = radioButtons.querySelectorAll('label');
                var ltdElement = void 0;
                allLabels.forEach(function (lbl) {
                    lbl.addEventListener('click', function (evt) {
                        var thisLabel = evt.target.nodeName === 'LABEL' ? evt.target : evt.target.closest('label');
                        allLabels.forEach(function (el) {
                            if (thisLabel === el) {
                                el.classList.add('selected');
                            } else {
                                el.classList.remove('selected');
                            }
                        });
                        try {
                            var planId = thisLabel.querySelector('input[type="radio"]').getAttribute('data-plnid');
                            document.getElementById('plansinsetid').value = planId;
                        } catch (e) {
                            console.error('problem!  could not get planid/279: ', thisLabel);
                        }
                    });
                    try {
                        var radioEl = lbl.querySelector('[name="whichSubscr"]');
                        if (radioEl.getAttribute('data-plnid') === '0') {
                            ltdElement = lbl;
                        }
                    } catch (e) {} // eslint-disable-line
                });
                // THIS IS WHERE I WAS PUTTING IN THE THREE DASHES.  DISABLED FOR NOW.
                if (ltdElement) {
                    try {
                        ltdElement.querySelector('span.saleprice').innerHTML = MHi18n && MHi18n.general && MHi18n.general.free || "Free";
                    } catch (e) {}
                }
            }).catch(function (er) {
                console.error('initSubscrRadioClicks.err:', er);
            });
        },
        BrowserLoc: {
            getLoc: function getLoc() {
                var prom = (0, _Browser.requestLatLonBrowserData)();
                prom.then(function (pos) {
                    _this2.navLatLonData = pos;
                }, function () {
                    // console.error('could not get info from this.navLatLonData');
                });
                return prom;
            },
            forceSetCoords: function forceSetCoords(lat, lon) {
                if (lat && lon) {
                    _this2.navLatLonData = _this2.navLatLonData || {};
                    _this2.navLatLonData.coords = {
                        latitude: lat,
                        longitude: lon
                    };
                } else {
                    console.error('BrowserLoc.forceSet BAD ARGS: ', lat, lon);
                }
            },
            getCoords: function getCoords() {
                // this is for the form submission
                var data = void 0;
                if (_this2.navLatLonData && _this2.navLatLonData.coords) {
                    data = {
                        loc_lat: _this2.navLatLonData.coords.latitude,
                        loc_lon: _this2.navLatLonData.coords.longitude
                    };
                }
                return data;
            }
        },
        setupLogRegSwitcher: function setupLogRegSwitcher() {
            var _this3 = this;

            console.assert(this.qsa('[data-secswitch]').length > 0, 'couldn\'t find this.qsa([data-secswitch])');
            this.qsa('[data-secswitch]').forEach(function (el) {
                el.addEventListener('click', _this3.logRegSwitcher);
            });
        },
        logRegSwitcher: function logRegSwitcher(evt) {
            if (evt && evt.target) {
                evt.preventDefault();
                evt.stopPropagation();
                if (evt.target.getAttribute('data-secswitch') === 'reg') {
                    this.switchToReg();
                } else {
                    this.switchToLogin();
                }
            } else {
                console.error(scriptName + ' setup-log-reg-switcher failed: no evt');
            }
        },
        setLocHash: function setLocHash(toLogin) {
            var h = window.location.hash;
            var newHash = void 0;
            if (toLogin && h !== HASH_LOG) {
                newHash = HASH_LOG;
            } else if (!toLogin && h === HASH_LOG) {
                newHash = HASH_REG;
            }
            if (newHash) {
                window.location.hash = newHash;
            }
        },
        switchLoginReg: function switchLoginReg(toLogin) {
            var tmp = void 0,
                showem = this.qsa('[data-secfunc=reg]'),
                hidem = this.qsa('[data-secfunc=login]');
            if (toLogin) {
                tmp = showem;
                showem = hidem;
                hidem = tmp;
            }
            showem.forEach(function (el) {
                if (el.classList) {
                    el.classList.remove('hidden');
                }
            });
            hidem.forEach(function (el) {
                if (el.classList) {
                    el.classList.add('hidden');
                }
            });
            this.setLocHash(toLogin ? 'toLogin' : false);
            if (!toLogin) {
                this.clearRegForm();
            }
            GOOGLE_ANAL('send', 'event', 'rapidpurch-switch-form-to', toLogin ? 'login' : 'rapidreg');
        },
        switchToLogin: function switchToLogin() {
            this.switchLoginReg(true);
        },
        switchToReg: function switchToReg() {
            this.switchLoginReg(false);
        },
        clearRegForm: function clearRegForm() {
            var F = this.regForm;
            if (!F) {
                F = document.getElementById('rapidreg');
            }
            var nameF = F.querySelector('#reg-name');
            var nameP = F.querySelector('#reg-password');
            try {
                nameF.value = '';
                nameP.value = '';
            } catch (e) {}
            // clear validation errors.  we cleared u&p values, but this triggers validation error on un.
            document.querySelectorAll('.regFb.err').forEach(function (el) {
                try {
                    el.remove();
                } catch (e) {}
            });
            document.querySelectorAll('.input-field').forEach(function (el) {
                try {
                    el.classList.remove('err');el.classList.remove('succ');
                } catch (e) {}
            });
        },
        doLogin: function doLogin() {
            // console.log('%cdoLogin called', 'color:red');
            var request = new XMLHttpRequest();
            var postUrl = '/user/login';
            var fd = new FormData();
            var u = this.qs('#loginusername').value.trim();
            var p = this.qs('#loginpassword').value.trim();
            fd.append('name', u);
            fd.append('pass', p);
            fd.append('rapidpurch', 'true');
            request.open('POST', postUrl, true);
            request.onload = function () {
                var errTxt = window.fbTrs.genErrCcs;
                if (request.status >= 200 && request.status < 400) {
                    window.location.href = '/welcome';
                } else {
                    if (request.status == 403) {
                        errTxt = window.fbTrs.badLogin;
                    } else if (request.statusText) {
                        if (request.statusText === 'Login Failed') {
                            errTxt = window.fbTrs.badLogin;
                        } else {
                            console.error('random error logging in 223: ', request.statusText);
                        }
                    }
                    (0, _loginSharedEs.throwModal)({
                        html: errTxt,
                        title: window.fbTrs.note,
                        addClass: 'narrow'
                    });
                }
            }.bind(this);
            request.onerror = function () {
                console.error('There was a connection error when logging in: ', request);
            };
            request.send(fd);
        },
        forwardToPurch: function forwardToPurch() {
            var planid = void 0,
                pisid = void 0,
                selectd = void 0,
                planInfoDispl = void 0,
                pidQsPart = '';
            try {
                selectd = this.qs('[name=whichSubscr]:checked');
                if (selectd) {
                    pisid = selectd.getAttribute('data-pisid');
                    planid = selectd.getAttribute('data-plnid');
                } else {
                    ///@todo NEED TO THROW AN ALERT SAYING PLEASE CHOOSE A PLAN!
                }

                planInfoDispl = encodeSessPlanInfo();
                if (planInfoDispl) {
                    // planInfoDispl = JSON.stringify(planInfoDispl);
                    pidQsPart = '&' + planInfoDispl;
                }
                // console.log('sending to billing server: ', document.location.pathname.replace('purchase', 'finish') + `?sub=${planid}&pis=${pisid}${pidQsPart}`);
                document.location.href = document.location.pathname.replace('purchase', 'finish') + ('?sub=' + planid + '&pis=' + pisid + pidQsPart);
            } catch (e) {
                console.error('in rapid purch submit, no subscription was chosen 205');
            }
        },
        rapidRegOnSuccessSegpay: function (args) {
            // console.log('>>rapidRegOnSuccessSegpay called: ', args);
            var usernameArg = args && args.success && args.success.username;
            var rrfdspnJson = sessionStorage.getItem('rrfdspn');
            var rrfdspn = JSON.parse(rrfdspnJson);
            // console.log('>>rapidRegOnSuccessSegpay DATA: u, p, s', rrfdspn.u, rrfdspn.p, rrfdspn.s, rrfdspn.gr);

            var fd = new FormData();
            fd.append('name', rrfdspn.u);
            fd.append('pass', rrfdspn.p);
            fd.append('rapidpurch', 'true');

            axios.post('/user/login', fd).then(function (response) {
                // console.log('LOGIN RESPONSE: ', response, rrfdspn);
                if (response.status >= 200 && response.status < 400) {
                    window.location.href = '/myaccount/rapidpurchase?p=' + rrfdspn.s;
                } else {
                    if (response.statusText) {
                        if (response.statusText === 'Login Failed') {
                            console.error('Login Failed in 501: ', response.statusText);
                        } else {
                            console.error('random error logging in 503: ', response.statusText);
                        }
                    }
                }
            }).catch(function (err) {});
        }.bind(this)
    }; // END v5RP

    function encodeSessPlanInfo() {
        var ret = void 0;
        var cid = _loginShared.sessionPlanInfo.get();
        // planName, salePrice, origPrice
        if (cid.planName && cid.salePrice) {
            ret = 'cidpn=' + encodeURIComponent(cid.planName) + '&cidsp=' + encodeURIComponent(cid.salePrice);
            if (cid.origPrice) {
                ret += '&cidop=' + encodeURIComponent(cid.origPrice);
            }
        }
        return ret;
    }

    var showTos = function showTos(evt) {
        var el = evt && evt.target,
            url = el && el.getAttribute && el.getAttribute('data-url');
        evt.stopPropagation();
        evt.preventDefault();

        var title = void 0;
        try {
            title = el.innerHTML.trim();
        } catch (e) {}
        var oReq = new XMLHttpRequest();
        oReq.open("POST", url, true);
        oReq.onload = function () {
            var respData = void 0;
            if (oReq.status === 200) {
                respData = oReq.response;
                (0, _loginSharedEs.throwModal)({
                    title: title,
                    html: respData
                });
                GOOGLE_ANAL('send', 'event', 'rr2-show-legal', url.split('/').find(function (t) {
                    return t ? true : false;
                }));
            } else {
                console.error('error fetching legal data 549: ', oReq);
            }
        };
        oReq.onerror = function () {
            console.error('error fetching legal data 553: ', oReq);
            GOOGLE_ANAL('send', 'event', 'rr2-show-legal', 'error');
        };
        oReq.send();
    };
    document.getElementById('pseudolink').addEventListener('click', function (e) {
        // console.log('pseudolink click: ', e);
        e.preventDefault();
        e.stopPropagation();
        showTos(e);
    });

    if ((0, _Browser.isDevHost)()) {
        console.groupCollapsed('init v5rapidPurch.es6.js');
    }
    (0, _DryFunctions.bindAllFuncs)(v5RP, {
        verbose: (0, _Browser.isDevHost)() ? true : false,
        name: 'v5rapidPurch.es6'
    });
    if ((0, _Browser.isDevHost)()) {
        console.groupEnd();
    }
    v5RP.initialize();
    return v5RP;
};
module.exports = v5rapPurch;

},{"../../common/js/modules/Browser.es6":1,"../../common/js/modules/DryFunctions.es6":3,"../../common/js/modules/GoogleAnalyticsMH.es6":4,"../../common/js/util/util_dom.es6.js":8,"./loginShared.es6":9,"./loginShared.es6.js":9,"./rapidPurchRegFormHelper.es6.js":10,"axios":13}],12:[function(require,module,exports){
/*jshint unused:true, eqnull:true, curly:true */
/*jshint esversion: 5, devel: true */
/*jshint strict:true, browserify: true */
/*jshint -W097 */
'use strict';
window.easeOutCubic = window.easeOutCubic || function (currentIteration, startValue, changeInValue, totalIterations) {
        return changeInValue * (Math.pow(currentIteration / totalIterations - 1, 3) + 1) + startValue;
    };
var MicroEvent = require('../../common/js/plugins/MicroEvent');
var v5RapidPurch = require('./v5rapidPurch.es6');
MicroEvent.mixin(document.body);
document.addEventListener('DOMContentLoaded', function () {
    var v5rp,
        isPaidEl = document.querySelector('#rrUserIsPaid');
    if (isPaidEl) {
        ;
    } else {
        v5rp = new v5RapidPurch();
    }
    window.rapidpurch = v5rp;
});
},{"../../common/js/plugins/MicroEvent":6,"./v5rapidPurch.es6":11}],13:[function(require,module,exports){
module.exports = require('./lib/axios');
},{"./lib/axios":15}],14:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var settle = require('./../core/settle');
var buildURL = require('./../helpers/buildURL');
var buildFullPath = require('../core/buildFullPath');
var parseHeaders = require('./../helpers/parseHeaders');
var isURLSameOrigin = require('./../helpers/isURLSameOrigin');
var createError = require('../core/createError');

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = require('./../helpers/cookies');

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

},{"../core/buildFullPath":21,"../core/createError":22,"./../core/settle":26,"./../helpers/buildURL":30,"./../helpers/cookies":32,"./../helpers/isURLSameOrigin":34,"./../helpers/parseHeaders":36,"./../utils":38}],15:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var bind = require('./helpers/bind');
var Axios = require('./core/Axios');
var mergeConfig = require('./core/mergeConfig');
var defaults = require('./defaults');

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = require('./cancel/Cancel');
axios.CancelToken = require('./cancel/CancelToken');
axios.isCancel = require('./cancel/isCancel');

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = require('./helpers/spread');

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

},{"./cancel/Cancel":16,"./cancel/CancelToken":17,"./cancel/isCancel":18,"./core/Axios":19,"./core/mergeConfig":25,"./defaults":28,"./helpers/bind":29,"./helpers/spread":37,"./utils":38}],16:[function(require,module,exports){
'use strict';

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

},{}],17:[function(require,module,exports){
'use strict';

var Cancel = require('./Cancel');

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

},{"./Cancel":16}],18:[function(require,module,exports){
'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

},{}],19:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var buildURL = require('../helpers/buildURL');
var InterceptorManager = require('./InterceptorManager');
var dispatchRequest = require('./dispatchRequest');
var mergeConfig = require('./mergeConfig');

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

},{"../helpers/buildURL":30,"./../utils":38,"./InterceptorManager":20,"./dispatchRequest":23,"./mergeConfig":25}],20:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

},{"./../utils":38}],21:[function(require,module,exports){
'use strict';

var isAbsoluteURL = require('../helpers/isAbsoluteURL');
var combineURLs = require('../helpers/combineURLs');

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

},{"../helpers/combineURLs":31,"../helpers/isAbsoluteURL":33}],22:[function(require,module,exports){
'use strict';

var enhanceError = require('./enhanceError');

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

},{"./enhanceError":24}],23:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var transformData = require('./transformData');
var isCancel = require('../cancel/isCancel');
var defaults = require('../defaults');

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

},{"../cancel/isCancel":18,"../defaults":28,"./../utils":38,"./transformData":27}],24:[function(require,module,exports){
'use strict';

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

},{}],25:[function(require,module,exports){
'use strict';

var utils = require('../utils');

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};

},{"../utils":38}],26:[function(require,module,exports){
'use strict';

var createError = require('./createError');

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};

},{"./createError":22}],27:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};

},{"./../utils":38}],28:[function(require,module,exports){
(function (process){(function (){
'use strict';

var utils = require('./utils');
var normalizeHeaderName = require('./helpers/normalizeHeaderName');

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = require('./adapters/xhr');
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = require('./adapters/http');
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

}).call(this)}).call(this,require('_process'))
},{"./adapters/http":14,"./adapters/xhr":14,"./helpers/normalizeHeaderName":35,"./utils":38,"_process":39}],29:[function(require,module,exports){
'use strict';

module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

},{}],30:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

},{"./../utils":38}],31:[function(require,module,exports){
'use strict';

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

},{}],32:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

},{"./../utils":38}],33:[function(require,module,exports){
'use strict';

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

},{}],34:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

},{"./../utils":38}],35:[function(require,module,exports){
'use strict';

var utils = require('../utils');

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

},{"../utils":38}],36:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

},{"./../utils":38}],37:[function(require,module,exports){
'use strict';

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

},{}],38:[function(require,module,exports){
'use strict';

var bind = require('./helpers/bind');

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};

},{"./helpers/bind":29}],39:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}]},{},[12]);
